<template>
  <div class="container">
      <swiper v-if="eventSlider.length>0" :options="swiperOptionSport">
        <swiper-slide  v-for="(item,key) in eventSlider" :key="key">
          <router-link :to="'/' + item.url">
            <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
          </router-link>
        </swiper-slide>
        <div v-if="!isMobile" class="sport-swiper-button-next swiper-button-prev" slot="button-prev">
          <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"> <g> <g> <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        </div>
        <div v-if="!isMobile" class="sport-swiper-button-prev swiper-button-next" slot="button-next">
          <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"> <g> <g> <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        </div>
    </swiper>
    <div class="banners ">
        <div class="row">
          <div class="col">
              <router-link to="/sportsbook">
                <img src="@/assets/images/common/homebox/box-1.png" width="100%">
              </router-link>
          </div>
          <div class="col">
              <router-link to="/casino">
                <img src="@/assets/images/common/homebox/box-2.png" width="100%">
              </router-link>
          </div>
          <div class="col">
              <router-link to="/slot">
                <img src="@/assets/images/common/homebox/box-3.png" width="100%">
              </router-link>
          </div>
          <div class="col">
              <router-link to="/aviator">
                <img src="@/assets/images/common/homebox/box-4.png" width="100%">
              </router-link>
          </div>
        </div>
    </div>
    <AmusnetJackpot ></AmusnetJackpot>
    <div class="slot-banners">
        <h1>EN YENİ SLOT OYUNLARIMIZ</h1>
        <div class="row row-wrap">
          <div class="col item" v-for="item in slotGames">
              <router-link :to="'/' + item.url">
                <img width="100%" :src="$store.state.main.cdn_url + item.image"/>
              </router-link>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import Jackpot from '../Common/Jackpot'
  import Game from '../Casino/Game'
  import AmusnetJackpot from '../Slot/AmusnetJackpot';
  import UserLogin from '../../views/Auth/Login'
  export default {
    components:{
      Game,
      UserLogin,
      AmusnetJackpot,
      Jackpot
    },
    data() {
      return {
        rightSlider:[],
        partners:[],
        leaguesList:[],
        newSlot: [],
        loginModal: false,
        isLoadingCasino: false,
        isLoadingWinners: false,
        isLoadingSlot: false,
        isLoadingEvents: false,
        swiperOptionWinners: {
					speed: 500,
          slidesPerView: 4,
          autoplay: {
            delay: 2000,
					},
          navigation: {
            nextEl: '.winner-swiper-button-next',
            prevEl: '.winner-swiper-button-prev'
          }
        },
        swiperOptionLeft: {
					speed: 1500,
          slidesPerView: 1,
          effect: 'cube',
          grabCursor: true,
          cubeEffect: {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          },
          autoplay: {
            delay: 2000,
					},
          navigation: {
            nextEl: '.casino-swiper-button-next',
            prevEl: '.casino-swiper-button-prev'
          }
        },
        swiperOptionSport: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 1000,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 2500,
          },
          navigation: {
            nextEl: '.sport-swiper-button-next',
            prevEl: '.sport-swiper-button-prev'
          },
          effect: 'fadein',
          grabCursor: true,
        },
        slotGames:[],
        eventSlider:[],
        leftSlider:[]
      }
    },
    mounted(){
      
    },
    created(){
      setTimeout(() => {
        this.fetchData()
      }, 1000);
    },
    methods:{
      fetchData: function() {
          this.$store.dispatch('getBanner', ['home', 'both', 'top'])
          .then(response =>{
            this.eventSlider = _.sortBy(response.data, ['sort'])
          });

          this.$store.dispatch('getBanner', ['home', 'both', 'bottom'])
          .then(response =>{
            this.slotGames = _.sortBy(response.data, ['sort'])
          });
      },
    },
    computed:{
      egt_show(){
        if(this.locale == 'TR' && this.user && this.user.balance > 0){
          return true
        }else{
          return false
        }
      },
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
      user(){
        return this.$user();
      },
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      locale(){
          return this.$store.getters.getLocale;
      },
      specialTemplate(){
          return this.$store.getters.getSpecialTemplate;
      }
    },
  }
</script>